import type { XbrlMappingStatus } from "@/apis/reference-search/types";

/** 표지·안내 문구. "매핑 없음"이 아니라 왜 없는지를 말한다 — 표마다 근거 없음으로 읽히면 틀린 단언이다. */
export const MAPPING_STATUS_LABEL: Record<XbrlMappingStatus | "unknown", string> = {
  mapped: "XBRL 매핑",
  notes_not_tagged: "주석 상세 태깅 없음",
  no_filing: "XBRL 원본 없음",
  failed: "매핑 실패",
  unknown: "매핑 정보 없음",
};
